import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { Modal, Text, Button } from '@simplybenefits/sb-ui-library';
import BookletRow from './BookletRow.js';
import { uploadMemberBooklet, changeBookletStatusForClass, changeBookletStatusForAccount } from '../../../actions/accounts.js';
import permissionLevel from '../../../services/permissions.js';
import FileDropZoneModal from '../../../components/FileDropZoneModal.js';
import loadingGif from '../../../assets/loading.gif';
import * as notifier from '../../../actions/notifier.js';
import { getPdf } from '../../../actions/master.js';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';


class Booklets extends PureComponent {
    state = {
        modalType: false,
        selectedClass: false,
        url: '',
        bookletLoading: false,
        anchorEl: null
    };

    _previewManualInTab = (item) => {
        const url = `https://d6hvupc5g7lnm.cloudfront.net/member-booklets/${ this.props.account.accountID }/${ item.classID }.pdf`;
        window.open(url, '_blank');
    };

    _uploadPDF = async (files) => {
        const data = {
            title: this.state.selectedClass.title,
            description: this.state.selectedClass.description,
            classID: this.state.selectedClass.classID,
            hasBooklet: 1
        };

        const accountID = this.props.account.accountID;

        const form = new FormData();
        form.append("file", files[0]);

        const success = await this.props.dispatch(uploadMemberBooklet(data, accountID, form));

        if (success) {
            this.setState({
                modal: false
            });
        }
    };

    _toggleModal = (type, item) => {
        this.setState({
            modalType: type,
            selectedClass: {
                ...item
            }
        });
    };

    _closeModal = () => {
        this.setState({
            modalType: null,
            bookletLoading: false
        });
    };

    _changeStatusClass = () => {
        this.props.dispatch(changeBookletStatusForClass(this.state.selectedClass.classID, this.state.selectedClass.newStatus));
    };

    _changeStatusAccount = (status) => {
        this.props.dispatch(changeBookletStatusForAccount(this.props.account.accountID, status));
    };

    _generateAutoBooklet = async (item) => {
        const employeeInClass = this.props.employees.find((employee) => employee.classID === item.classID && employee.cert !== null);

        if (!employeeInClass) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'There must be at least one enrolled member under the class to generate the automated booklet.'
            }));

            return;
        }

        this.setState({
            bookletLoading: true
        });

        await this.props.dispatch(getPdf("MemberBooklet", "Simply_Benefits_Member_Booklet.pdf", { userID: employeeInClass.userID }));

        this.setState({
            bookletLoading: false
        });
    };

    _toggleMenu = (event) => {
        this.setState({
            isBookletActionsMenu: !this.state.isBookletActionsMenu,
            anchorEl: event.currentTarget
        }); 
    };

    _handleCloseMenu = () => {
        this.setState({ anchorEl: false });
    };

    _handleOpenMenu = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    render() {
        const { accessType } = this.props;
        const writeAccess = permissionLevel('Member Booklets', accessType).includes('write');

        const styles = {
            modalRow: {
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            },
            gif: {
                maxWidth: '25%',
                marginRight: 40
            },
            actionMenuContainer: {
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: 20,
                marginBottom: 20
            },
            actionMenuButton: {
                fontSize: 16,
                width: 170,
                height: 45
            }
        };

        return (
            <div>
                {
                    writeAccess ?
                        <div style={ styles.actionMenuContainer }>
                            <Button
                                color="primary"
                                customStyle={ styles.actionMenuButton }
                                onClick={ this._handleOpenMenu }
                            >
                                Booklet Actions
                            </Button>
                            <Menu
                                anchorEl={ this.state.anchorEl }
                                open={ Boolean(this.state.anchorEl) }
                                onClose={ this._handleCloseMenu }
                                disableAutoFocusItem={ true }
                            >
                                <MenuItem 
                                    onClick={ () => {
                                        this._handleCloseMenu();
                                        this._toggleModal("enableAll", false);
                                    }}
                                >
                                    <Text>Enable Automated Booklets</Text>
                                </MenuItem>

                                <MenuItem 
                                    onClick={ () => {
                                        this._handleCloseMenu();
                                        this._toggleModal("disableAll", false);
                                    }}
                                >
                                    <Text>Disable Booklets</Text>
                                </MenuItem>
                            </Menu>
                        </div>
                        : null
                }

                <BookletRow isHeader={true} />

                {
                    Object.keys(this.props.accountClasses).map((classID) => {
                        const item = this.props.accountClasses[classID];

                        if (item.isModular && item.parentClassID === null) {
                            return null;
                        }

                        return (
                            <BookletRow
                                selected={ item.classID === this.state.selectedClass.classID }
                                key={ item.classID }
                                item={ item }
                                previewManual={ () => this._previewManualInTab(item) }
                                generateAutomated={ () => this._generateAutoBooklet(item) }
                                replace={ () => this._toggleModal('Replace', item) }
                                upload={ () => this._toggleModal('Upload', item) }
                                setStatus={ (status) => this._toggleModal('Status', { ...item, newStatus: status }) }
                                hasBooklet={ item.hasBooklet }
                                canWrite={ writeAccess }
                            />
                        );
                    })
                }

                {
                    this.state.modalType === "Upload" &&
                        <FileDropZoneModal
                            title={ `Class: '${ this.state.selectedClass.title }'` }
                            instructions={ `Please select Member Booklet for Class: '${ this.state.selectedClass.title }, ${ this.state.selectedClass.description }'` }
                            hideModal={ this._closeModal }
                            showModal={ Boolean(this.state.modalType) }
                            maxItems={ 1 }
                            type="Member Booklet"
                            submitFile={ this._uploadPDF }
                            acceptedFiles="application/pdf, .pdf"
                        />
                }

                {
                    this.state.modalType === "Replace" &&
                        <FileDropZoneModal
                            title={ `Replace Class: '${ this.state.selectedClass.title }' Booklet` }
                            instructions={ `Please select Member Booklet for Class: '${ this.state.selectedClass.title }, ${ this.state.selectedClass.description }' This will replace the existing booklet for this class, and leave the other booklets for this account unaffected.` }
                            hideModal={ this._closeModal }
                            showModal={ Boolean(this.state.modalType) }
                            maxItems={ 1 }
                            type="Member Booklet"
                            submitFile={ this._uploadPDF }
                            acceptedFiles="application/pdf, .pdf"
                        />
                }

                {
                    this.state.modalType === 'Status' &&
                        <Modal
                            open={true}
                            onClose={ this._closeModal }
                            title="Are you sure?"
                            primaryButton={{
                                label: "Confirm",
                                onClick: this._changeStatusClass
                            }}
                            loader={ this.props.loader }
                        >
                            {
                                this.state.selectedClass.newStatus === 'disable' &&
                                    <Text medium>
                                        { `By selecting Confirm below you will be disabling booklets for all members in the ${ this.state.selectedClass.title } class.` }
                                    </Text>
                            }

                            {
                                this.state.selectedClass.newStatus === 'automated' &&
                                    <Text medium>
                                        { `By selecting Confirm below you will be enabling automated booklets for all members in the ${ this.state.selectedClass.title } class.` }
                                    </Text>
                            }

                            {
                                this.state.selectedClass.newStatus === 'manual' &&
                                    <Text medium>
                                        { `By selecting Confirm below you will be setting all members in the ${ this.state.selectedClass.title } class to use the manual booklet currently uploaded for ${ this.state.selectedClass.title }.` }
                                    </Text>
                            }
                        </Modal>
                }

                {
                    this.state.bookletLoading &&
                        <Modal
                            open={ true }
                            onClose={ this._closeModal }
                            title="Booklet Downloading"
                            loader={ this.props.loader }
                        >
                            <div style={ styles.modalRow }>
                                <img style={ styles.gif } src={ loadingGif } alt="loading..." />

                                <Text
                                    small
                                    margin="10px 0 5px 0"
                                    customStyle={{ width: "65%" }}
                                >
                                    Your booklet is being generated and will be automatically downloaded once ready.
                                </Text>
                            </div>
                        </Modal>
                }

                {
                    this.state.modalType === "enableAll" ?
                        <Modal
                            open={true}
                            onClose={ this._closeModal }
                            title="Automated Booklets for All Classes"
                            primaryButton={{
                                label: "Confirm",
                                onClick: () => {
                                    this._changeStatusAccount("automated"); 
                                }
                            }}
                            loader={ this.props.loader }
                            style={{
                                width: '650px'
                            }}
                        >
                            <Text>
                                By selecting Confirm below you will be enabling automated booklets for all classes in this account.
                            </Text>  
                        </Modal>
                        : null
                }

                {
                    this.state.modalType === "disableAll" ?
                        <Modal
                            open={true}
                            onClose={ this._closeModal }
                            title="Booklets for All Classes"
                            primaryButton={{
                                label: "Confirm",
                                onClick: () => {
                                    this._changeStatusAccount("disable");
                                }
                            }}
                            loader={ this.props.loader }
                        >
                            <Text>
                                By selecting Confirm below, you will disable all booklets — including both automated and manual — for every class in this account.
                            </Text> 
                        </Modal>
                        : null
                }
            </div>
        );
    }
}

Booklets.propTypes = {
    accountClasses: PropTypes.object,
    account: PropTypes.object,
    accessType: PropTypes.string,
    master: PropTypes.object
};

/**
 * @param state
 * @returns {{selectedBill: null, admin: null, history: Array, currentBill: null}}
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accountClasses: state.accounts.currentAccount.classes,
    employees: state.accounts.currentAccount.employees,
    account: state.accounts.currentAccount.meta,
    accessType: state.master.access,
    master: state.master
});

export default connect(mapStateToProps)(Booklets);